import { memoize } from "lodash-es";

import { IWithRouteMatchProps, IWithRoutePropsProps } from "@/infrastructure/Route";

interface ContractDetailsMatchParams {
  contractId: number;
}

interface ContractDetailsRouteParams {
  contractId: number;
}

type ContractDetailsMatchProps = IWithRouteMatchProps<ContractDetailsMatchParams>;
export type ContractDetailsRouteProps = IWithRoutePropsProps<ContractDetailsRouteParams>;

const transformRoutePropsBody = (props: ContractDetailsMatchProps) => {
  return { contractId: props.match.params.contractId };
};

const transformRoutePropsResolver = (props: ContractDetailsRouteProps) => {
  return props.location.pathname;
};

export const transformRouteProps = memoize(transformRoutePropsBody, transformRoutePropsResolver);
